import * as React from "react";
import Modal from "@mui/material/Modal";
import { Form, Formik } from "formik";
import { SectionColumn, SectionRow } from "../../layouts/sections";
import TextField2 from "../../features/auth/components/TextField2";
import { OtherDropDown_Validation } from "../../Helpers/formikValidation";
import RoundedButton from "../buttons/RoundedButtons";
import { selectionDropDownPutValuesNewCapital } from "../../Helpers/selectionDropDownHelper";
import { closePopupIcon, forwardIcon } from "../../Helpers/ICONS";
import { ModalOpenCloseContext } from "../../app/context/modalOpenCloseContext";

const OtherDropDownModal = (props) => {

  //  Contexts
  const { otherDropDownPopupModal, setOtherDropDownPopupModal } = React.useContext(ModalOpenCloseContext);

  const handleClose = () => {
    props.setOtherDropDownValue(selectionDropDownPutValuesNewCapital("Other"));
    setOtherDropDownPopupModal(false);
  }

  const handleSubmit = (values) => {
    props.setOtherDropDownValue(selectionDropDownPutValuesNewCapital(values.nameOfAccreditation));
    setOtherDropDownPopupModal(false);
  };

  const handleValidate = (values) => { };

  return (
    <div>
      <Modal
        hideBackdrop
        open={otherDropDownPopupModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="modalBackDrop"
      >
        <div className="addStakeholderWrapper">
          <div className="addOtherDropdownCard flex justify-center">
            <div className="">
              <span className="cursor-pointer absolute -top-2 -right-2 border-2 border-white rounded-full h-7">
                <img
                  src={closePopupIcon}
                  alt={"Close"}
                  width={24}
                  height={24}
                  onClick={() => {
                    handleClose();
                  }}
                />
              </span>
            </div>
            <SectionColumn>
              <span className="pt-7 font-bold text-center">
                Enter Other Name of Certification Body
              </span>

              <SectionRow className="justify-center gap-3 pb-4">
                <Formik
                  initialValues={{ nameOfAccreditation: "" }}
                  onSubmit={handleSubmit}
                  validate={handleValidate}
                  validationSchema={OtherDropDown_Validation}
                  validator={() => ({})}
                >
                  {(formik) => (
                    <Form>
                      <SectionColumn>
                        <TextField2
                          heading=""
                          formType="certificationForm"
                          type="text"
                          name={`nameOfAccreditation`}
                          className={"certificationBodyInputsField w-1/2"}
                          placeholder="Enter Name of Certification Body"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.nameOfAccreditation}
                          maxLength={60}
                        />

                        <div className="pt-4 flex justify-end">
                          <RoundedButton
                            ref={undefined}
                            onClick={undefined}
                            className="primaryButton certificationFormButton"
                            type="submit"
                          >
                            <SectionRow>
                              <span className="pr-3">Submit</span>
                              <img
                                src={forwardIcon}
                                alt="Picture of the author"
                              // width={12}
                              // height={12}
                              />
                            </SectionRow>
                          </RoundedButton>
                        </div>
                      </SectionColumn>
                    </Form>
                  )}
                </Formik>
              </SectionRow>
            </SectionColumn>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default OtherDropDownModal;
